import React, { Fragment, Component, useContext } from "react";
import _ from "lodash";
import Skeleton from "react-loading-skeleton";
import DetailItem from "../../../../../../components/detailItem";
import { Accordion, Card } from "react-bootstrap";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import textFormatService from "../../../../../../services/utility/textFormatService";

export function ContextAwareToggle({ eventKey, level }) {
  const currentEventKey = useContext(AccordionContext);
  const toggleOnClick = useAccordionToggle(eventKey);
  const isCurrentEventKey = currentEventKey === eventKey;
  const angleType = isCurrentEventKey ? "fa fa-angle-up" : "fa fa-angle-down";
  return (
    <Card.Header onClick={toggleOnClick} style={{ cursor: "pointer" }}>
      <b>Collateral {level}</b>
      <i
        className={angleType}
        aria-hidden="true"
        style={{ float: "right" }}
      ></i>
    </Card.Header>
  );
}

interface CollateralDetailsProps {
  values: any;
  handleChange: any;
  handleBlur: any;
}

interface CollateralDetailsState {
  item: any;
}

class CollateralDetails extends Component<CollateralDetailsProps, CollateralDetailsState> {
  constructor(props: CollateralDetailsProps) {
    super(props);
    this.state = {
      item: {},
    };
  }

  static getDerivedStateFromProps(nextProps: CollateralDetailsProps, prevState) {
    return {
      item: nextProps.values.collaterals,
    };
  }

  render() {
    const { values } = this.props;

    return (
      <Fragment>
        <div className="card">
          <div className="card-header clear-fix">
            {_.isEmpty(values) ? (
              <Skeleton width={200} />
            ) : (
              <h6
                className="card-title float-left"
                style={{ marginBottom: "0px" }}
              >
                <b>Collateral Details</b>
              </h6>
            )}
          </div>

          <Accordion defaultActiveKey="0">
            <Card>
              <Accordion.Collapse eventKey={`0`}>
                <Card.Body>
                  <div style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                    <div className="row">
                      <div className="col-md-12">
                        {_.isEmpty(values.collaterals) ? (
                          <div style={{ textAlign: "center", color: "#FE825E" }}>
                            No Collateral has been assigned to Loan Request
                          </div>
                        ) : (
                          <div>
                            {values.collaterals.map((item, idx) => (
                              <div key={idx}>
                                <Accordion defaultActiveKey={`${idx}`}>
                                  <Card>
                                    <ContextAwareToggle
                                      eventKey={`${idx}`}
                                      level={idx + 1}
                                    ></ContextAwareToggle>
                                    <Accordion.Collapse eventKey={`${idx}`}>
                                      <Card.Body className={"rule-card-body"}>
                                        <div className="card-body">
                                          <div className="row">
                                            <div className="col-md-6">
                                              <dl className="row">
                                                <DetailItem
                                                  label="Category"
                                                  labelSize={7}
                                                  valueSize={5}
                                                  value={item.category}
                                                />
                                                <DetailItem
                                                  label="Description"
                                                  labelSize={7}
                                                  valueSize={5}
                                                  value={item.description}
                                                />
                                                {item.category === "Property" ? (
                                                  <React.Fragment>
                                                    <DetailItem
                                                      label="Property Size"
                                                      labelSize={7}
                                                      valueSize={5}
                                                      value={item.propSize}
                                                    />
                                                    <DetailItem
                                                      label="Property Location"
                                                      labelSize={7}
                                                      valueSize={5}
                                                      value={item.propLocation}
                                                    />
                                                  </React.Fragment>
                                                ) : ("")}
                                              </dl>
                                            </div>
                                            <div className="col-md-6">
                                              <dl className="row">
                                                <DetailItem
                                                  label="Type"
                                                  labelSize={7}
                                                  valueSize={5}
                                                  value={item.type}
                                                />
                                                <DetailItem
                                                  label="Value"
                                                  labelSize={7}
                                                  valueSize={5}
                                                  value={textFormatService.formatCurrency(Number(item.value), 2)}
                                                />
                                                {item.category === "Property" ? (
                                                  <React.Fragment>
                                                    <DetailItem
                                                      label="Ownership Structure"
                                                      labelSize={7}
                                                      valueSize={5}
                                                      value={item.ownershipStructure}
                                                    />
                                                    <DetailItem
                                                      label="Serial Registration Number"
                                                      labelSize={7}
                                                      valueSize={5}
                                                      value={item.serialNo}
                                                    />
                                                  </React.Fragment>
                                                ) : ("")}
                                              </dl>
                                            </div>
                                          </div>
                                        </div>
                                      </Card.Body>
                                    </Accordion.Collapse>
                                  </Card>
                                </Accordion>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>

        </div>
      </Fragment>
    );
  }
}

export default CollateralDetails;